import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './VenueDetail.css';

function Garden() {
  const [space, setSpace] = useState(null);

  useEffect(() => {
    client
      .fetch('*[_type == "venue"][0]{ spaces[slug == "garden"][0] }')
      .then(data => {
        if (data && data.spaces) setSpace(data.spaces);
      });
  }, []);

  const images = (space && space.images) || [];
  const validImages = images.filter(img => img && img.asset);

  return (
    <div className="venue-detail-page">
      <SEO
        title="정원 | Garden"
        description="가든포에트 정원 - 나비가 날아다니고, 고양이가 거니는 동화 같은 야외 정원. 가든 웨딩, 야외 예식, 플라워 세레모니."
        path="/venue/garden"
      />
      <section className="detail-hero">
        <div className="container">
          <div className="detail-hero-content fade-in">
            <h1>GARDEN</h1>
            <p className="capacity-tag">수용 인원: 30-50명</p>
          </div>
        </div>
      </section>

      <section className="detail-description">
        <div className="container">
          <div className="space-notice fade-in">
            <span className="notice-tag">📷 시즌 프리뷰</span>
          </div>
          <div className="description-content fade-in">
            <p>
              작은 자작나무 묘목이 20년 넘게 자라서<br />
              작은 숲이 된 정원입니다.<br />
              이 정원은 20년 넘게 매년 봄마다<br />
              정성스레 화원으로 가꿔왔습니다.
            </p>
            <p>
              낭만적인 테라코타 벽돌길을 따라<br />
              내추럴하게 자란 화원 사이로 신부가 걸어오면,<br />
              자작 나무 아래에서 성혼서약을 맹세합니다.
            </p>
            <p>
              30분 예식 후 식사를 하고 헤어지는 예식이<br />
              편할 수는 있어도<br />
              바람, 햇살, 그리고 주변의 꽃과 허브의 향이 기억나는 예식은<br />
              축하와 힐링의 순간을 함께 가져다 줄거예요.
            </p>
            <p>
              자작나무 주변에 사람들이 모여 진심으로 축하를 해주고,<br />
              동화 같은 정원에서 사진 한 장 한 장이 특별해집니다.<br />
              자유롭게 야외 바베큐나 케이터링도 좋으며,<br />
              비가 오면 유럽의 야외 테라스처럼<br />
              파라솔과 우산 아래에서 운치 있는 예식을 진행합니다.
            </p>
            <p className="closing">
              식사는 실내 공간에서 편안하게 하시고,<br />
              예식은 야외에서 아름답게 만드시길 바래요.<br />
              동화 같은 순간으로 기억이 남는 결혼식이길 바랍니다.
            </p>
          </div>
        </div>
      </section>

      {validImages.length > 0 && (
        <section className="detail-gallery">
          <div className="container-wide">
            <div className="gallery-grid fade-in">
              {validImages.map(function(image, i) {
                return (
                  <div key={i} className="gallery-item">
                    <img 
                      src={urlFor(image).width(800).url()} 
                      alt={`정원 ${i + 1}`}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Garden;
